var DEFAULT_COOPPAY_DESTINATION = 'coop@isle.ph';
var DEFAULT_LIGHTNING_DESTINATION = 'coop@coinos.io';
var GOOGLE_SCRIPT_URL = 'https://script.google.com/macros/s/AKfycbzVA62DHIO1GnUt1EEOaytthXqeM_TnWgvoQ9GyDCNN0yb-UcoenKOefhu5gcsiw-3-/exec';

var currentProduct = {
  id: '',
  title: '',
  handle: '',
  vendor: '',
  price: '',
  tags: [],
  cooppayDestination: '',
  lightningDestination: '',
  isCartPayment: false,
  cartHasVpi: false,
  cartToken: '',
  cartItemCount: 0,
  cartTotal: '',
  cartItemsSummary: ''
};

var currentMode = 'cooppay';
var currentFormStage = 'delivery';
var stagedVPIData = {
  vin: '',
  email: '',
  part_reference: '',
  notes: ''
};

function ensureModalAtBodyLevel() {
  var modal = document.getElementById('coopQRModal');
  if (modal && modal.parentNode !== document.body) {
    document.body.appendChild(modal);
  }
}

function hasTag(tag) {
  return currentProduct.tags.indexOf(tag) !== -1;
}

function isCartPayment() {
  return currentProduct.isCartPayment === true;
}

function isVPIContext() {
  if (isCartPayment()) {
    return currentProduct.cartHasVpi === true;
  }
  return hasTag('vpi');
}

function determineInitialFormStage() {
  if (isVPIContext()) {
    return 'vin';
  }
  return 'delivery';
}

function resetStagedVPIData() {
  stagedVPIData = {
    vin: '',
    email: '',
    part_reference: '',
    notes: ''
  };
}

function updateModalTitle(stage) {
  var title = document.getElementById('coopQRTitle');
  var railLabel = currentMode === 'coinos' ? 'Lightning' : 'CoopPay';

  if (stage === 'form') {
    if (currentFormStage === 'vin') {
      title.textContent = railLabel + ' → VIN Details';
      return;
    }

    title.textContent = railLabel + ' → Delivery';
    return;
  }

  title.textContent = currentMode === 'coinos'
    ? 'Lightning Payments'
    : 'CoopPay Payment';
}

function renderFormFields() {
  var wrap = document.getElementById('coopQRDynamicFields');
  var submitButton = document.getElementById('coopQRSubmitButton');
  var shippingNote = document.getElementById('coopQRShippingNote');

  if (currentFormStage === 'vin') {
    wrap.innerHTML = `
      <input type="text" id="vpiVin" name="vin" class="coop-qr-input" placeholder="VIN" required>
      <input type="email" id="vpiEmail" name="email" class="coop-qr-input" placeholder="Email" required>
      <input type="text" id="vpiPartReference" name="part_reference" class="coop-qr-input" placeholder="Part reference (optional)">
      <textarea id="vpiNotes" name="notes" class="coop-qr-input coop-qr-textarea" placeholder="Notes (optional)"></textarea>
    `;

    submitButton.textContent = isCartPayment()
      ? 'Continue to Delivery'
      : 'Submit VIN Details';

    shippingNote.textContent = isCartPayment()
      ? 'Submit VIN details first, then delivery details for the physical component of this order.'
      : 'Payment covers the digital verification service. Submit VIN details so we can process your request.';

    return;
  }

  wrap.innerHTML = `
    <input type="text" id="buyerName" name="buyer_name" class="coop-qr-input" placeholder="Your name" required>
    <input type="text" id="buyerMobile" name="buyer_mobile" class="coop-qr-input" placeholder="Mobile number" required>
    <textarea id="buyerAddress" name="buyer_address" class="coop-qr-input coop-qr-textarea" placeholder="Delivery address" required></textarea>
    <textarea id="buyerNote" name="buyer_note" class="coop-qr-input coop-qr-textarea" placeholder="Optional note"></textarea>
  `;

  submitButton.textContent = 'Submit Delivery Details';

  if (isCartPayment()) {
    shippingNote.textContent = 'This payment is for your current procurement-run cart total. Shipping fees will be calculated separately after we review your delivery address.';
  } else {
    shippingNote.textContent = 'This payment contributes to a procurement run. Runs execute once totals reach ₱20,000. Product payment only. Shipping fees will be calculated separately after we review your delivery address.';
  }
}

function openCoopQRModal(button) {
  ensureModalAtBodyLevel();

  currentProduct.id = button.dataset.productId || '';
  currentProduct.title = button.dataset.productTitle || '';
  currentProduct.handle = button.dataset.productHandle || '';
  currentProduct.vendor = button.dataset.productVendor || '';
  currentProduct.price = button.dataset.productPrice || '';

  currentProduct.tags = (button.dataset.productTags || '')
    .split(',')
    .map(function(tag){ return tag.trim().toLowerCase(); })
    .filter(function(tag){ return tag !== ''; });

  currentProduct.cooppayDestination = button.dataset.cooppayDestination || DEFAULT_COOPPAY_DESTINATION;
  currentProduct.lightningDestination = button.dataset.lightningDestination || DEFAULT_LIGHTNING_DESTINATION;

  currentProduct.isCartPayment = button.dataset.cartMode === 'true';
  currentProduct.cartHasVpi = button.dataset.cartHasVpi === 'true';
  currentProduct.cartToken = button.dataset.cartToken || '';
  currentProduct.cartItemCount = parseInt(button.dataset.cartItemCount || '0', 10);
  currentProduct.cartTotal = button.dataset.cartTotal || '';
  currentProduct.cartItemsSummary = button.dataset.cartItemsSummary || '';

  currentFormStage = determineInitialFormStage();
  resetStagedVPIData();

  document.getElementById('coopQRModal').style.display = 'flex';
  document.body.style.overflow = 'hidden';

  document.getElementById('coopQRFormWrap').style.display = 'none';
  document.getElementById('coopQRFormMessage').textContent = '';
  document.getElementById('coopQRForm').reset();

  document.getElementById('coopQRImageWrap').style.display = 'block';
  document.getElementById('coopQRCaption').style.display = 'block';
  document.getElementById('coopQRShippingNote').style.display = 'block';
  document.getElementById('coopQRFootnote').style.display = 'block';
  document.getElementById('coopQRPaidButton').style.display = 'block';
  document.querySelector('.coop-qr-tabs').style.display = 'inline-flex';
  document.getElementById('coopQRText').style.display = 'block';

  renderFormFields();
  setCoopQRMode('cooppay');
}

function closeCoopQRModal() {
  document.getElementById('coopQRModal').style.display = 'none';
  document.body.style.overflow = '';
}

function renderQRCode(text) {
  var qrContainer = document.getElementById('coopQRImage');
  qrContainer.innerHTML = '';

  if (!text) {
    qrContainer.innerHTML = '<div class="coop-qr-placeholder">Payment destination not set.</div>';
    return;
  }

  new QRCode(qrContainer, {
    text: text,
    width: 228,
    height: 228
  });
}

function setCoopQRMode(mode) {
  currentMode = mode;

  var caption = document.getElementById('coopQRCaption');
  var shippingNote = document.getElementById('coopQRShippingNote');
  var footnote = document.getElementById('coopQRFootnote');

  var coopPayTab = document.getElementById('coopQRTabCoopPay');
  var coinosTab = document.getElementById('coopQRTabCoinos');

  if (mode === 'coinos') {
    renderQRCode(currentProduct.lightningDestination);

    caption.textContent = 'Use this if you do not have CoopPay but have a Lightning wallet, e.g. Blink, Strike, Aqua, Phoenix, etc.';

    if (currentFormStage === 'vin') {
      shippingNote.textContent = isCartPayment()
        ? 'Submit VIN details first, then delivery details for the physical component of this order.'
        : 'Payment covers the digital verification service. Submit VIN details so we can process your request.';
    } else {
      if (isCartPayment()) {
        shippingNote.textContent = 'This payment is for your current procurement-run cart total. Shipping fees will be calculated separately after we review your delivery address.';
      } else {
        shippingNote.textContent = 'This payment contributes to a procurement run. Runs execute once totals reach ₱20,000. Product payment only. Shipping fees will be calculated separately after we review your delivery address.';
      }
    }

    footnote.textContent = 'CoopPay users may prefer the CoopPay option above for zero-fee peso-to-peso payments.';

    coopPayTab.classList.remove('is-active');
    coinosTab.classList.add('is-active');
    coopPayTab.setAttribute('aria-pressed', 'false');
    coinosTab.setAttribute('aria-pressed', 'true');
  } else {
    renderQRCode(currentProduct.cooppayDestination);

    caption.textContent = 'Best for CoopPay users. Scan with CoopPay to pay instantly. Zero fee, peso-to-peso payments.';

    if (currentFormStage === 'vin') {
      shippingNote.textContent = isCartPayment()
        ? 'Submit VIN details first, then delivery details for the physical component of this order.'
        : 'Payment covers the digital verification service. Submit VIN details so we can process your request.';
    } else {
      if (isCartPayment()) {
        shippingNote.textContent = 'This payment is for your current procurement-run cart total. Shipping fees will be calculated separately after we review your delivery address.';
      } else {
        shippingNote.textContent = 'This payment contributes to a procurement run. Runs execute once totals reach ₱20,000. Product payment only. Shipping fees will be calculated separately after we review your delivery address.';
      }
    }

    footnote.textContent = 'CoopPay was built by One Cooperative Technology Services, the Philippines’ first and only technology services federation. CoopPay is the world’s first Lightning wallet for coops.';

    coopPayTab.classList.add('is-active');
    coinosTab.classList.remove('is-active');
    coopPayTab.setAttribute('aria-pressed', 'true');
    coinosTab.setAttribute('aria-pressed', 'false');
  }

  updateModalTitle('payment');
}

document.addEventListener('DOMContentLoaded', function () {
  var paidButton = document.getElementById('coopQRPaidButton');
  var form = document.getElementById('coopQRForm');

  if (paidButton) {
    paidButton.addEventListener('click', function () {
      document.getElementById('coopQRImageWrap').style.display = 'none';
      document.getElementById('coopQRCaption').style.display = 'none';
      document.getElementById('coopQRShippingNote').style.display = 'none';
      document.getElementById('coopQRFootnote').style.display = 'none';
      document.getElementById('coopQRPaidButton').style.display = 'none';
      document.querySelector('.coop-qr-tabs').style.display = 'none';
      document.getElementById('coopQRText').style.display = 'none';

      renderFormFields();
      updateModalTitle('form');

      document.getElementById('coopQRFormWrap').style.display = 'block';

      var firstField = currentFormStage === 'vin'
        ? document.getElementById('vpiVin')
        : document.getElementById('buyerName');

      if (firstField) firstField.focus();
    });
  }

  if (form) {
    form.addEventListener('submit', function (event) {
      event.preventDefault();

      var message = document.getElementById('coopQRFormMessage');
      var submitButton = form.querySelector('button[type="submit"]');

      var selectedDestination = currentMode === 'cooppay'
        ? currentProduct.cooppayDestination
        : currentProduct.lightningDestination;

      if (submitButton.disabled) return;

      if (currentFormStage === 'vin' && isVPIContext() && isCartPayment()) {
        stagedVPIData.vin = document.getElementById('vpiVin').value;
        stagedVPIData.email = document.getElementById('vpiEmail').value;
        stagedVPIData.part_reference = document.getElementById('vpiPartReference').value;
        stagedVPIData.notes = document.getElementById('vpiNotes').value;

        currentFormStage = 'delivery';
        renderFormFields();
        updateModalTitle('form');
        message.textContent = '';

        var nextField = document.getElementById('buyerName');
        if (nextField) nextField.focus();

        return;
      }

      message.textContent = 'Submitting...';
      submitButton.disabled = true;

      var payload = {
        product_id: currentProduct.id,
        product_title: currentProduct.title,
        product_handle: currentProduct.handle,
        product_vendor: currentProduct.vendor,
        product_tags: currentProduct.tags.join(','),
        product_price: currentProduct.price,
        selected_rail: currentMode,
        selected_destination: selectedDestination,
        form_mode: isVPIContext() ? 'vpi' : 'delivery',
        page_url: window.location.href,
        is_cart_payment: isCartPayment() ? 'yes' : 'no',
        cart_token: currentProduct.cartToken,
        cart_item_count: currentProduct.cartItemCount,
        cart_total: currentProduct.cartTotal,
        cart_items_summary: currentProduct.cartItemsSummary
      };

      if (isVPIContext()) {
        if (isCartPayment()) {
          payload.vin = stagedVPIData.vin;
          payload.part_reference = stagedVPIData.part_reference;
          payload.verification_email = stagedVPIData.email;
          payload.verification_note = stagedVPIData.notes;

          payload.buyer_name = document.getElementById('buyerName').value;
          payload.buyer_mobile = document.getElementById('buyerMobile').value;
          payload.buyer_address = document.getElementById('buyerAddress').value;
          payload.buyer_note = document.getElementById('buyerNote').value;
        } else {
          payload.vin = document.getElementById('vpiVin').value;
          payload.part_reference = document.getElementById('vpiPartReference').value;
          payload.verification_email = document.getElementById('vpiEmail').value;
          payload.verification_note = document.getElementById('vpiNotes').value;
        }
      } else {
        payload.buyer_name = document.getElementById('buyerName').value;
        payload.buyer_mobile = document.getElementById('buyerMobile').value;
        payload.buyer_address = document.getElementById('buyerAddress').value;
        payload.buyer_note = document.getElementById('buyerNote').value;
      }

      fetch(GOOGLE_SCRIPT_URL, {
        method: 'POST',
        body: JSON.stringify(payload)
      })
      .then(function(response) {
        if (!response.ok) throw new Error('Network error');
        return response.text();
      })
      .then(function() {
        message.textContent = isVPIContext()
          ? 'Details submitted successfully.'
          : 'Delivery details submitted successfully.';

        form.reset();
        currentFormStage = determineInitialFormStage();
        resetStagedVPIData();
        renderFormFields();
      })
      .catch(function() {
        message.textContent = 'There was an error submitting your details. Please try again.';
      })
      .finally(function() {
        submitButton.disabled = false;
      });
    });
  }
});

document.addEventListener('click', function(e){
  var btn = e.target.closest('[data-quickpay-cart]');
  if (!btn) return;
  openCoopQRModal(btn);
});